import findDuplicates from "../../scripts/calculatePotions/findDuplicates";
import { effects } from "../data/effects";
import { dedupe } from "../utils/dedupe";

export const Potions = {
    potion(
        alchemyProficiency,
        ...ingredients
    ) {
        if (!ingredients.length) {
            return null;
        }

        let effects = ingredients.flatMap(it => dedupe(it.effects.slice(0, alchemyProficiency)));
        let matchingEffects = findDuplicates({ data: effects });

        if (!matchingEffects.length) {
            return null;
        }

        return savePotion(matchingEffects, ingredients, alchemyProficiency);
    }
}

function savePotion(matchingEffects, ingredients, alchemyProficiency) {
    return {
        name: "",
        weight: +ingredients.reduce((acc, it) => acc + it.weight, 0).toFixed(2),
        value: +ingredients.reduce((acc, it) => acc + it.value, 0).toFixed(2),
        effects: matchingEffects,
        positiveEffectCount: matchingEffects.reduce((acc, it) => acc + isPositive(it), 0),
        alchemyProficiency,
        ingredients
    }
}

function isPositive(effect) {
    return effects[effect].positive ? 1 : 0;
}